import React from "react";
import { Container, Form, Row, Col, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState, useEffect, useRef } from "react";
import { CSVLink } from "react-csv";
import { Button, Spinner } from "reactstrap";
import { downloadCSVReport } from "helpers/backend_helper";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import cross from "../../assets/images/icon/cross.svg";
import threedots from "../../assets/images/icon/three-dots.svg";
import {
  updatestatus,
  FetchFilterInfo,
  getFilteredList,
} from "services/pendingService";
import { FetchRejectedList } from "../../services/rejectedService";
import api from "../../api";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import user_icons1 from "../../assets/images/icon/user-ico7.svg";
import { toast } from "react-toastify";

import {
  checkPermissionStatus,
  generateMaskedPII,
  useDebounce,
  getSubdomain
} from "helpers/utils";
import { getFilterStatus } from "helpers/common";
import { MultiSelect } from "react-multi-select-component";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { Trans, useTranslation } from "react-i18next";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RemotePagination from "components/Common/RemotePagination";
import SearchBar from "components/Common/Searchbar";

function RejectedList(props) {
  const getDashboardFilterData = key => {
    let payloadObj = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    if (!key || !payloadObj?.filterValue) {
      return;
    }
    let dashboardFilters = localStorage.getItem("dashboardFilters")
      ? JSON.parse(localStorage.getItem("dashboardFilters"))
      : {};
    return dashboardFilters?.[key] || "";
  };
  const { t } = useTranslation();
  const [rejectedData, setRejectedData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const [roleTypes, setRoleTypes] = useState([]);
  const [selectedRoleOptions, setSelectedRoleOptions] = useState([]);
  const [gender, setGender] = useState("");
  const [sourceType, setSourceType] = useState([]);
  const [source, setSource] = useState("");
  const [states, setStates] = useState([]);
  const [state, setState] = useState("");
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState("");
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [city, setCity] = useState("");
  const [startDate, setStartDate] = useState(
    getDashboardFilterData("startDate")
      ? new Date(getDashboardFilterData("startDate"))
      : ""
  );
  const [endDate, setEndDate] = useState(
    getDashboardFilterData("endDate")
      ? new Date(getDashboardFilterData("endDate"))
      : ""
  );
  const [type, setType] = useState(getDashboardFilterData("type") || "");
  const [query, setQuery] = useState("");
  const [commentError, setCommentError] = useState("");
  const [csvData, setCSVData] = useState([]);

  //filter initilization
  const [testStatus, setTestStatus] = useState("");
  const [interviewStatusFilter, setInterviewStatusFilter] = useState("");
  const [offerLetterStatus, setOfferLetterStatus] = useState("");

  const [totalCounts, setTotalCounts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);

  const testtatusOptions = [
    { value: "0", label: t(`ATS View.Pending`) },
    { value: "1", label: t(`ATS View.Scheduled`) },
    { value: "2", label: t(`ATS View.Skip`) },
    { value: "3", label: t(`ATS View.On Hold`) },
    { value: "4", label: t(`ATS View.Completed`) },
    { value: "5", label: t(`ATS View.Shortlisted`) },
    { value: "6", label: t(`ATS View.Not Attempted`) },
  ];
  const interviewStatusOptions = getFilterStatus(2);

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = {};
    let selectedIds = [];
    let allData = rejectedData?.map(el => {
      if (el?.checked) {
        selectedIds.push(el?.appl_id);
      }
      return el;
    });
    if (selectedIds?.length > 0) {
      data = {
        type: "selective",
        candidateIds: selectedIds?.join(","),
        listType: "rejected",
      };
    } else {
      data = {
        type: "All",
        candidateIds: "",
        listType: "rejected",
      };
    }

    try {
      await downloadCSVReport(data)
        .then(res => {
          let csvData = res?.data?.map(item => ({
            ...item,
            email_id: generateMaskedPII(item?.email_id),
            mobile: generateMaskedPII(item?.mobile, 2),
          }));
          setCSVData(csvData);
          setTimeout(() => {
            let element = document.getElementById("downloadCSV");
            element.click();
          }, 1000);
        })
        .catch(err => {
          console.log(err);
          return [];
        });
    } catch (err) {
      return [];
    }
  };
  const getRejectedList = async (current = 1, size = 10, query_text = "", sort_field = sortField, sort_order = sortOrder) => {
    setLoading(true);
    await FetchRejectedList({
      page: current,
      queryText: query_text,
      pageSize: size,
      ...(sort_field && { sortField: sort_field, sortOrder: sort_order }),
    })
      .then(res => {
        if (res.data.status) {
          setRejectedData(res?.data?.data);
          setTotalCounts(res.data?.total_counts);
          setLoading(false);
        } else {
          toast.error(t(`all-application.No data Available`));
          setLoading(false);
        }
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`all-application.Something Went Wrong`);
        toast.error(errMsg);
        setLoading(false);
      });
  };
  // Fetch Faqs listing data
  useEffect(() => {
    if (type) {
      handleSubmit();
    } else {
      getRejectedList(1, 10);
    }
    getFilterInfo();
    document.title = "NeuroTal - Rejected Applications";
  }, []);

  const handleGenderChange = e => {
    if (gender === e.target.name) {
      setGender("");
    } else {
      setGender(e.target.name);
    }
  };

  const getFilterInfo = async () => {
    await FetchFilterInfo()
      .then(res => {
        let filterData = res?.data?.data || "";
        if (filterData) {
          setCities(filterData?.cities || []);
          setAreas(filterData?.areas || []);
          setRoleTypes(filterData?.roles || []);
          setSourceType(filterData?.sources || []);
          setStates(filterData?.states || []);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allUsers = rejectedData?.map(el => {
      if (el?.appl_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setRejectedData(allUsers);
  };

  const [comment, setComment] = useState("");
  const handleChange = e => {
    setComment(e.target.value);
    setCommentError("");
  };

  const validateComment = () => {
    if (!comment.trim()) {
      setCommentError(t(`all-application.Comment required`));
      return false;
    }
    // You can add more validation rules here if needed
    return true;
  };
  const handleConfirm = async (appl_id, status, comment) => {
    if (loading) return;
    if (validateComment()) {
      console.log("comment", comment);
      setLoading(true);
      await updatestatus(appl_id, status, comment, 5)
        .then(res => {
          if (res.status === 200) {
            if (status === 5) {
              toast.success(t(`all-application.Record Rejected`));
            } else if (status === 4) {
              toast.success(t(`all-application.Record Onhold`));
            } else {
              toast.success(t(`all-application.Comment Added`));
            }
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      console.log("Validation error:", commentError);
    }
    getRejectedList();
  };

    function calculateDaysAgo(applyDate) {
    const applyDateObj = new Date(applyDate);
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = currentDate - applyDateObj;

    // Convert milliseconds to days (1000 ms in a second, 60 seconds in a minute, 60 minutes in an hour, 24 hours in a day)
    const daysAgo = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return daysAgo;
  }
const cityColumn = {
  dataField: "master_city.city",
  text: t(`all-application.City`),
  classes: "application-normal",
};

  const columns = [
    {
      dataField: "appl_id",
      text: t(`all-application.Appl No`),
      classes: "total app-col sticky-col",
      headerClasses: "app-col sticky-col",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const formattedDate =
          row.appl_id +
          "/" +
          (applyDate.getMonth() + 1) +
          "" +
          applyDate.getFullYear();
        return (
          <div className="date-tabel">
            <input
              id={`checkbox-${row?.appl_id}`} // Ensure a unique ID for each checkbox
              defaultChecked={row?.checked || false}
              onClick={e => handleCheck(e, row?.appl_id)}
              type="checkbox"
              className="d-none"
            />
            <label htmlFor={`checkbox-${row?.appl_id}`}>{formattedDate}</label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: t(`all-application.Name`),
      classes: "application-name name-col sticky-col",
      headerClasses: "name-col sticky-col",
      sort: true,
      formatter: (cell, row) => (
        <span
          className="clickable-link"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/candidate_consolidate/view-details/${row.appl_id}`);
          }}
        >
          {cell.toLowerCase()}
        </span>
      ),
    },
    {
      dataField: "email_id",
      text: t(`all-application.Email Id`),
      classes: "application-email ",
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    // {
    //   dataField: "mobile",
    //   text: "Mobile No.",
    //   classes: "application-normal",
    // },
    // {
    //   dataField: "job_user.gender",
    //   text: "Gender",
    //   classes: "application-normal",
    // },
    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`all-application.Education`),
      classes: "application-normal educations",
      sort: true,
    },
    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`all-application.Education`),
      classes: "application-normal educations",
      sort: true,
    },
    {
      dataField: "vacancy.title",
      text: t(`all-application.Job Role`),
      classes: "application-normal educations",
      sort: false,
    },
     {
      dataField: "vacancy.franchise.franchise_name",
      text: t(`all-application.dealer_name`),
      classes: "application-normal educations",
      sort: false,
    },
    {
      dataField: "job_user.total_experience",
      text: t(`all-application.Total Exp`),
      classes: "application-normal",
      sort: true,
    },

    {
      dataField: "rejectReason",
      text: t(`all-application.Rejection_Reason`),
      classes: "application-normal rejected-appl",
      headerClasses: "application-normal rejected-appl",
      formatter: cell => cell || "-",
    },

    {
      dataField: "rejectComment",
      text: t(`all-application.Rejection Comment`),
      classes: "application-normal rejected-appl",
      headerClasses: "application-normal rejected-appl",
      formatter: cell => cell || "-",
    },

     ...(getSubdomain() !== "mahindra" ? [cityColumn] : []),
        {
      dataField: "apply_date",
      text: t(`all-application.Applied on`),
      classes: "application-normal",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const today = new Date();
        const isToday = applyDate.toDateString() === today.toDateString(); // Compare date parts only

        const daysAgo = calculateDaysAgo(applyDate);

        return (
          <div className="date-tabel">
            <label>
              {isToday
                ? t(`all-application.Today`)
                : `${daysAgo} ${t(`all-application.days ago`)}`}
            </label>
          </div>
        );
      },
    },
  {
      dataField: "creator.name",
      text: t(`all-application.created_by`),
      classes: "application-normal",
    },
    {
      dataField: "",
      text: t(`all-application.Actions`),
      formatter: (cell, row) => {
        let appl_id = row.appl_id;
        let user_id = row.user_id;

        return (
          <div className="action-application">
            <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  aria-label="More options"
                >
                  <img src={threedots} alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {checkPermissionStatus("rejected-list", "edit") && (
                    <>
                      <Dropdown.Item
                        onClick={() => handleChangeStatus(appl_id)}
                      >
                        {t(`all-application.Move to New Applications`)}
                      </Dropdown.Item>
                    </>
                  )}
                  {checkPermissionStatus("rejected-list", "view") && (
                    <>
                      <Dropdown.Item
                        onClick={() => {
                          history.push(
                            `/candidate_consolidate/view-details/${appl_id}`
                          );
                        }}
                      >
                        {t(`all-application.View Details`)}
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          history.push(`/printpending-list/${appl_id}`);
                        }}
                      >
                        {t(`all-application.Print Report`)}
                      </Dropdown.Item>
                    </>
                  )}
                  {checkPermissionStatus("rejected-list", "create") && (
                    <>
                      <Dropdown.Item onClick={() => open_slider(appl_id, 0)}>
                        {t(`all-application.Add Comment`)}
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
  ];
  const [isComment, setIsComment] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState({});
  const closes = () => {
    setIsComment(false);
    setCommentError("");
  };

  const handleChangeStatus = async appl_id => {
    const confirmation = window.confirm(
      t(`all-application.Move application to pending`)
    );

    if (!confirmation) {
      return false;
    }
    let otherDetails = {
      old_status: "Rejected Applications",
      new_status: `New Applications`,
    };
    await updatestatus(appl_id, 0, "", 5,null, otherDetails)
      .then(res => {
        handleSubmit();
        toast.success(t(`all-application.Application Updated`));
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`all-application.Something Went Wrong`);
        toast.error(errMsg);
      });
  };

  const open_slider = async (appl_id, status) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/common/fetch-details/${appl_id}`
      );
      const data = response.data;
      if (data.status && data.data.length > 0) {
        setCandidateDetails(data.data[0]);
      } else {
        console.error("Invalid data format received from API:", data);
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }
    if (status == 0) {
      setIsComment(!isComment);
    }
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`all-application.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = rejectedData.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (rejectedData.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [rejectedData.length]);

  const handleStateChange = e => {
    setCity("");
    setState(e.target.value);
    let cityList = cities?.filter(
      el => el?.state_id === parseInt(e.target.value)
    );
    setFilteredCities(cityList);
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const handleSubmit = (newState, defaultType) => {
    if (!newState) {
      setCurrentPage(1);
      setSizePerPage(10);
    }
    let payload = {
      type: "rejected",
      queryText: query,
      gender: gender,
      role: selectedRoleOptions,
      source: source,
      state: state,
      city: city,
      area: area,
      testStatus: testStatus,
      interviewStatusFilter: interviewStatusFilter,
      offerLetterStatus: offerLetterStatus,
    };
    if (defaultType || type) {
      payload.startDate = startDate;
      payload.endDate = endDate;
    }
    if (defaultType === "current" || type === "current") {
      payload.startDate = moment().startOf("month").format();
      payload.endDate = moment().endOf("month").format();
      setStartDate(moment().startOf("month").toDate());
      setEndDate(moment().endOf("month").toDate());
    } else if (type === "previous") {
      const start = moment().subtract(3, "months").toDate();
      const end = new Date();
        payload.startDate = moment(start).toISOString();
        payload.endDate = moment(end).toISOString();
        setStartDate(start);
        setEndDate(end);
    }
    const effectiveSortField = newState?.sortField !== undefined ? newState.sortField : sortField;
    const effectiveSortOrder = newState?.sortOrder !== undefined ? newState.sortOrder : sortOrder;
    const finalPayload = {
      ...(newState || payload),
      ...(effectiveSortField && { sortField: effectiveSortField, sortOrder: effectiveSortOrder }),
    };
    getFilteredList(finalPayload)
      .then(res => {
        if (res.data.status) {
          setRejectedData(res.data.data);
          setTotalCounts(res.data.total_counts);
          setIsFiltered(true);
        } else {
          toast.error(t(`all-application.No data Available`));
        }
        close();
      })
      .catch(err => console.log(err));
  };

  const clearFilters = () => {
    setGender("");
    setSelectedRoleOptions([]);
    setArea("");
    setState("");
    setCity("");
    setStartDate("");
    setEndDate("");
    setSource("");
    setTestStatus("");
    setInterviewStatusFilter("");
    setOfferLetterStatus("");
    getRejectedList();
    setCurrentPage(1);
    setSizePerPage(10);
    setIsFiltered(false);
    close();
    setType("");
  };
  const getFilterList = () => {
    let filterArray = [];

    // Gender filter
    if (gender) {
      filterArray.push({
        label: "Gender",
        value: gender,
        key: "gender",
      });
    }

    // Role filter
    if (selectedRoleOptions?.length > 0) {
      filterArray.push({
        label: "Job Position",
        value: selectedRoleOptions.map(item => item.label).join(", "),
        key: "role",
      });
    }

    // Test Status filter
    if (testStatus) {
      let statusLabel = testtatusOptions.find(
        el => el.value == testStatus
      )?.label;
      filterArray.push({
        label: "Test Status",
        value: statusLabel,
        key: "testStatus",
      });
    }

    // Interview Status filter
    if (interviewStatusFilter) {
      let statusLabel = interviewStatusOptions.find(
        el => el.value == interviewStatusFilter
      )?.label;
      filterArray.push({
        label: "Interview Status",
        value: statusLabel,
        key: "interviewStatus",
      });
    }

    // Source filter
    if (source) {
      let sourceLabel = sourceType.find(el => el.value == source)?.label;
      filterArray.push({
        label: "Source Type",
        value: sourceLabel,
        key: "source",
      });
    }

    // State filter
    if (state) {
      let stateLabel = states.find(el => el.value == state)?.label;
      filterArray.push({
        label: "State",
        value: stateLabel,
        key: "state",
      });
    }

    // City filter
    if (city) {
      let cityLabel = filteredCities.find(el => el.value == city)?.label;
      filterArray.push({
        label: "City",
        value: cityLabel,
        key: "city",
      });
    }

    // Date Range filter
    if (type) {
      filterArray.push({
        label: t("Date Range"),
        value:
          type === "current"
            ? t("Current Month")
            : type === "previous"
            ? t("Last 3 Months")
            : `${moment(startDate).format("DD MMM YYYY")} - ${moment(
                endDate
              ).format("DD MMM YYYY")}`,
        key: "type",
      });
    }

    return filterArray;
  };

  const handleFilterRemove = key => {
    const newState = {
      type: "rejected",
      queryText: query,
      gender,
      role: selectedRoleOptions,
      source,
      state,
      city,
      testStatus,
      interviewStatusFilter,
      area,
    };

    let defaultType = type;

    switch (key) {
      case "gender":
        setGender("");
        newState.gender = "";
        break;

      case "role":
        setSelectedRoleOptions([]);
        newState.role = [];
        break;

      case "testStatus":
        setTestStatus("");
        newState.testStatus = "";
        break;

      case "interviewStatus":
        setInterviewStatusFilter("");
        newState.interviewStatusFilter = "";
        break;

      case "source":
        setSource("");
        newState.source = "";
        break;

      case "state":
        setState("");
        setCity("");
        newState.state = "";
        newState.city = "";
        break;

      case "city":
        setCity("");
        newState.city = "";
        break;

      case "type":
        setType("");
        setStartDate("");
        setEndDate("");
        defaultType = "";
        break;
    }

    if (defaultType) {
      newState.startDate = startDate;
      newState.endDate = endDate;
    }

    handleSubmit(newState, defaultType);
  };

  ///modal
  const [isVisible, setIsVisible] = useState(false);

  const filter_icon = () => {
    setIsVisible(!isVisible);
  };

  const close = () => {
    setIsVisible(false);
  };

  

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const tabWrapperRef = useRef(null);

  const scrollLeft = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = isLang1OrLang2 ? 30 : 20; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1280) {
      moveDistance = isLang1OrLang2 ? 30 : 20;
    } else if (window.innerWidth < 1280) {
      moveDistance = isLang1OrLang2 ? 60 : 50;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(${moveDistance}px)`;
    }
  };

  const scrollRight = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = 150; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth >= 1280) {
      // Adjust based on lang-1 or lang-2
      if (bodyClassList.contains("lang-1")) {
        moveDistance = 380; // For lang-1
      } else if (bodyClassList.contains("lang-2")) {
        moveDistance = 100; // For lang-2
      } else {
        moveDistance = 380; // Default for 1280px+
      }
    } else if (window.innerWidth >= 1152) {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    } else {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(-${moveDistance}px)`;
    }
  };

  const handleTableChange = (type, { page, sizePerPage: ps, sortField: sf }) => {
    if (type === "sort") {
      const newOrder = sf === sortField
        ? (sortOrder === "asc" ? "desc" : "asc")
        : "asc";
      setSortField(sf);
      setSortOrder(newOrder);
      setCurrentPage(1);
      if (isFiltered) {
        handleSubmit({
          type: "rejected",
          gender, role: selectedRoleOptions, source, state, city, area,
          startDate, endDate, testStatus, interviewStatusFilter, offerLetterStatus,
          pageSize: ps || sizePerPage,
          page: 1,
          sortField: sf,
          sortOrder: newOrder,
        }, "");
      } else {
        getRejectedList(1, ps || sizePerPage, query, sf, newOrder);
      }
    } else {
      setCurrentPage(page);
      setSizePerPage(ps);
      if (isFiltered) {
        handleSubmit({
          type: "rejected",
          gender, role: selectedRoleOptions, source, state, city, area,
          startDate, endDate, testStatus, interviewStatusFilter, offerLetterStatus,
          pageSize: ps,
          page,
          ...(sortField && { sortField, sortOrder }),
        }, "");
      } else {
        getRejectedList(page, ps, query, sortField, sortOrder);
      }
    }
  };

  const handleSearch = async () => {
    handleSubmit();
    setCurrentPage(1);
  };
  if (!checkPermissionStatus("rejected-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`all-application.Access denied`)}</h4>
      </div>
    );
  }
  return (
    <>
      <div className="pending-list-page">
        <div className="tabbing-wrapper allap d-flex justify-content-between mt-2 mb-4 position-relative">
          <button className="arrow-btns" onClick={scrollLeft}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <button className="arrow-btns right" onClick={scrollRight}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            <ul
              className="tab-btn-wrapper d-flex align-items-center"
              ref={tabWrapperRef}
              style={{ transition: "transform 0.3s" }}
            >
              <li>
                <Link
                  to={`/all-applications${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="all-applications"
                >
                  {t(`all-application.All Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/pending-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="pending-list"
                >
                  {t(`all-application.New Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/screening-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="screening-list"
                >
                  {t(`all-application.In Progress Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/selected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="selected-list"
                >
                  {t(`all-application.Selected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onboarded-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onboarded-list"
                >
                  {t(`all-application.Onboarded Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onhold-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onhold-list"
                >
                  {t(`all-application.Onhold Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/rejected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link active"
                  id="rejected-list"
                >
                  {t(`all-application.Rejected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/archive-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="archive-list"
                >
                  {t(`all-application.Archived Applications`)}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="outerTab-box-wrapper applicationcard-table mobile-cards-view allapp-cation">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3">
                <div className="table-data-search">
                  <div className="total-record">
                    <h5>
                      {t(`all-application.Total Records`)}{" "}
                      <span>{totalCounts || 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <SearchBar
                      onSearch={handleSearch}
                      title={t(`all-application.Search by mobile2`)}
                      placeholder={
                        t(`all-application.Search by mobile`).slice(0, 40) +
                        "..."
                      }
                      query={query}
                      setQuery={setQuery}
                    />
                    {checkPermissionStatus("rejected-list", "downloadcsv") && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "appl_id",
                              label: t(`all-application.Application ID`),
                            },
                            {
                              key: "name",
                              label: t(`all-application.Name`),
                            },
                            {
                              key: "mobile",
                              label: t(`all-application.Mobile Number`),
                            },
                            {
                              key: "email_id",
                              label: t(`all-application.Email ID`),
                            },
                            {
                              key: "createdAt",
                              label: t(`all-application.Created Date`),
                            },
                            {
                              key: "f2f_address",
                              label: t(`all-application.Address`),
                            },
                          ]}
                          filename={`RejectedApplicationList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />{" "}
                            {t(`all-application.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}

                    <div className="take-text filter" onClick={filter_icon}>
                      <h5>
                        <span>
                          <img src={filtericon} alt="" />
                        </span>
                        {t(`all-application.Filters`)}
                      </h5>
                    </div>
                    <div className="tale-text right-panel alapp arrow-btns">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>

                {getFilterList()?.length > 0 && (
                  <div className="selected-data-card length-selected-data allapp mb-4">
                    {getFilterList()?.map((el, index) => {
                      return (
                        <div className="select-para" key={index}>
                          <p className="mb-0">
                            <span className="selected-tag text-capitalize">
                              {el?.label} - {el?.value}
                            </span>
                            <button
                              className="remove-tag-button"
                              onClick={() => handleFilterRemove(el?.key)}
                            >
                              &times;
                            </button>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className="timeto-hire-card userlist pendiglist-cardss">
                  {loading && (
                    <div className="m-3 p-3 text-center">
                      <Spinner size={"lg"} />{" "}
                      <div>{t(`all-application.Loading`)}</div>
                    </div>
                  )}
                  {!loading && (
                    <div className="table-custome-class range-custome">
                      {rejectedData?.length > 0 ? (
                        <>
                          <div className="scroll-container">
                            <div className="table-pending-list">
                              <div
                                className="table-wrapper"
                                ref={tableWrapperRef}
                              >
                                <RemotePagination
                                  keyField="appl_id"
                                  data={rejectedData}
                                  columns={columns}
                                  page={currentPage}
                                  sizePerPage={sizePerPage}
                                  totalSize={totalCounts}
                                  onTableChange={handleTableChange}
                                  rowClasses={rowClasses}
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <table className="table table-hover table-bordered">
                          <thead>
                            <tr>
                              <th>{t(`all-application.Appl No`)}</th>
                              <th>{t(`all-application.Name`)}</th>
                              <th>{t(`all-application.Email Id`)}</th>
                              <th>{t(`all-application.Mobile No`)}</th>
                              <th>{t(`all-application.Gender`)}</th>
                              <th>{t(`all-application.Education`)}</th>
                              <th>{t(`all-application.Total Exp`)}</th>
                              <th>{t(`all-application.Job Role`)}</th>
                              <th>{t(`all-application.City`)}</th>
                              <th>{t(`all-application.Actions`)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="10" className="text-center">
                                <div className="no-data data-available">
                                  <img
                                    src="../img/data-not-available.png"
                                    alt="data not availble"
                                  />
                                  <h3>{t(`all-application.No Item Found`)}</h3>
                                  <p>
                                    <Trans>
                                      {t(`all-application.No Item Msg`)}
                                    </Trans>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {isVisible && (
            <div className="filter-shadow filetr-cards">
              <div className="filters-cards">
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Filters`)}</h4>
                  </div>
                  <div className="filter-content cross" onClick={close}>
                    <img src={cross} alt="" />
                  </div>
                </div>
                <div className="bordertops"></div>
                <div className="application-gender">
                  <h5>{t(`Bulk Import.Select Applicant Gender`)}</h5>

                  <div className="application-button">
                    <div class="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Male"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Male"}
                        />
                        <span>{t(`Gender.Male`)}</span>
                      </label>
                    </div>
                    <div class="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Female"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Female"}
                        />
                        <span>{t(`Gender.Female`)} </span>
                      </label>
                    </div>
                    <div class="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Other"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Other"}
                        />
                        <span>{t(`Gender.Other`)}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="filter-cards-form">
                  <form class="form-inline">
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Job Position")}</label>

                      <div
                        title={
                          selectedRoleOptions.length
                            ? `${selectedRoleOptions
                                .map(option => option.label || option.name)
                                .join(", ")}`
                            : `Please ${t("ATS View.Select Job Position")}`
                        }
                      >
                        <MultiSelect
                          options={roleTypes}
                          value={selectedRoleOptions}
                          onChange={setSelectedRoleOptions}
                          labelledBy="Select Job Position"
                          placeholder="Select"
                          overrideStrings={{
                            selectSomeItems: t("ATS View.Select Job Position"),
                          }}
                        />
                      </div>
                    </div>
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Source Type")}</label>

                      <div
                        title={`${
                          source
                            ? sourceType.find(el => el.value == source)?.label
                            : t("ATS View.Select Source Type")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setSource(e.target.value)}
                          aria-label="Default select example"
                          value={source}
                        >
                          <option value="">
                            {t("ATS View.Select Source Type")}
                          </option>
                          {sourceType?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select State")}</label>

                      <div
                        title={`${
                          state
                            ? states.find(el => el.value == state)?.label
                            : t("ATS View.Select State")
                        }`}
                      >
                        <Form.Select
                          onChange={e => handleStateChange(e)}
                          aria-label="Default select example"
                          value={state}
                        >
                          <option value="">{t("ATS View.Select State")}</option>
                          {states?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select City")}</label>

                      <div
                        title={`${
                          city
                            ? filteredCities.find(el => el.value == city)?.label
                            : t("ATS View.Select City")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setCity(e.target.value)}
                          aria-label="Default select example"
                          value={city}
                        >
                          <option value="">{t("ATS View.Select City")}</option>
                          {filteredCities?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
                    {/* Test Status Dropdown */}
                    {getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Test Status")}</label>

                      <div
                        title={`${
                          testStatus
                            ? testtatusOptions.find(
                                el => el.value == testStatus
                              )?.label
                            : t("ATS View.Select Test Status")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setTestStatus(e.target.value)}
                          aria-label="Test Status"
                          value={testStatus}
                        >
                          <option value="">
                            {t("ATS View.Select Test Status")}
                          </option>
                          {testtatusOptions?.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </div>
                    )}
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="float-label">
                          {t(`all-application.Custom Date Range`)}
                        </Form.Label>
                        <div className="application-button mb-2">
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Current"}
                                onChange={e => {
                                  if (type === "curent") {
                                    setType("");
                                  } else {
                                    setType("current");
                                  }
                                }}
                                checked={type === "current"}
                              />
                              <span>{t(`all-application.Current`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Last 3 Months"}
                                onChange={e => {
                                  if (type === "previous") {
                                    setType("");
                                  } else {
                                    setType("previous");
                                  }
                                }}
                                checked={type === "previous"}
                              />
                              <span>{t(`all-application.Last 3 Months`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Custom"}
                                onChange={e => {
                                  if (type === "custom") {
                                    setType("");
                                  } else {
                                    setType("custom");
                                  }
                                }}
                                checked={type === "custom"}
                              />
                              <span>{t(`all-application.Custom`)}</span>
                            </label>
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                    {type === "custom" && (
                      <>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.Start Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.Start Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setStartDate(e);
                              }}
                              placeholderText={t(`all-application.Start Date`)}
                              id="date"
                              selected={startDate}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.End Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.End Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setEndDate(e);
                              }}
                              placeholderText={t(`all-application.End Date`)}
                              id="date"
                              selected={endDate}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
                  </form>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <button
                        className="btn btn-primary reset"
                        onClick={() => clearFilters()}
                      >
                        {t(`ATS View.Reset`)}
                      </button>
                      <button
                        className="btn btn-primary search"
                        onClick={() => handleSubmit()}
                      >
                        {t(`ATS View.Search`)}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Comment data popup */}
        {isComment && (
          <div className="filter-shadow reject-people-data">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Comment Application`)}</h4>
                </div>
                <div className="filter-content cross" onClick={closes}>
                  <img src={cross} alt="" />
                </div>
              </div>
              <div className="bordertops"></div>
              <div className="reject-people data justify-content-between">
                <div className="mobile-cards align-items-center">
                  <div className="reject-perople-user">
                    <img src={user_icons1} alt="user icon" />
                  </div>

                  <div className="header-plant">
                    <h4>{candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="reject-people-user-data">
                  <div className="header-plant ss">
                    <h4>{candidateDetails.name}</h4>
                  </div>

                  <div className="reject-people-user-data-card">
                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Job Role`)}</p>
                        <h4>{candidateDetails.vacancy?.title}</h4>
                      </div>
                    </div>
                    

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Education`)}</p>
                        <h4>
                          {
                            candidateDetails.master_reference_table
                              .highest_qualification
                          }
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Total Exp`)}</p>
                        <h4>{candidateDetails.job_user.total_experience}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-cards-form reject-data">
                <h4>{t(`all-application.Enter Comment`)}</h4>
                <p>{t(`all-application.Add Comment`)}</p>
                <form class="form-inline">
                  <div className="col-lg-12">
                    <Form.Group>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(`all-application.Compulsory Comment`)}
                        rows="3"
                        onChange={handleChange}
                      ></textarea>
                      {commentError && (
                        <div className="text-danger">{commentError}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <button class="btn btn-primary reset" onClick={closes}>
                        Reset
                      </button>
                      <a
                        href="javascript:void(0);"
                        id="next"
                        class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={!loading ? () => handleConfirm(candidateDetails.appl_id, 0, comment) : undefined}
                        style={loading ? { pointerEvents: "none", opacity: 0.6 } : {}}
                      >
                        {loading ? t("all-application.Please wait...") : t(`all-application.Comment`)}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="black-showd"></div>
          </div>
        )}
        {/* Comment data popup */}

        <div className="pending-list-page d-none">
          <Container fluid>
            <Row className="mb-3">
              <Col sm="6">
                <h5 className="text-uppercase">
                  {t(`all-application.Pending List`)}{" "}
                </h5>
              </Col>

              <Col
                sm="6"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              ></Col>
            </Row>
            {successMessage && (
              <div class="alert alert-success" role="alert">
                {successMessage}
              </div>
            )}

            <Row>
              <div className="pending-list-page">
                <div className="tabbing-wrapper d-flex justify-content-between mt-2 mb-4">
                  <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
                    <ul className="tab-btn-wrapper d-flex align-items-center">
                      <li>
                        <Link
                          href="javascript:void()"
                          className="tab-link active"
                          id="current-month"
                        >
                          {t(`all-application.Current Month`)}
                        </Link>
                      </li>
                      <li>
                        <Link
                          href="javascript:void()"
                          className="tab-link"
                          id="last-month"
                        >
                          {t(`all-application.Last 3 Months`)}
                        </Link>
                      </li>
                      <li>
                        <Link
                          href="javascript:void()"
                          className="tab-link"
                          id="custom"
                        >
                          {t(`all-application.Custom`)}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="tab-content">
                  {activeTab === "tab1" && (
                    <div className="tab-pane show active">
                      <ToolkitProvider
                        keyField="head1"
                        data={rejectedData}
                        columns={columns}
                        search
                      >
                        {props => (
                          <div>
                            <BootstrapTable
                              {...props.baseProps}
                              pagination={paginationFactory()}
                              options={options}
                              striped
                              hover
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  )}
                  {activeTab === "tab2" && (
                    <div className="tab-pane show active">
                      <p>{t(`all-application.Content of Tab 2`)}</p>
                    </div>
                  )}
                  {/* Add more tab content as needed */}
                </div>
              </div>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default RejectedList;
